import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, FlatButton, Paper } from 'material-ui';
import Subheader from 'material-ui/Subheader';
import errorIcon from '../../../resources/images/icons/error.svg';
import { connect } from 'react-redux';
import Loading from '../../../components/common/Loading/Loading';
import styles from './PushPage.css';
import style from '../../../styles/styles';
import Error from '../../../components/common/Error/Error';
import {
    fetchApp,
    getSubscribedPush,
    postPush,
    resetSubscribedPush,
} from '../../../store/apps/actions';
import PushForm from '../../../components/push/PushForm/PushForm';
import { Link } from 'react-router-dom';
import withTranslation from '../../../hoc/withTranslation';
import { SETTING_PAGE } from '../../../constants/routes';

export class PushPage extends React.Component {

    static propTypes = {
        app: PropTypes.object,
    };

    state = {
        pushModalOpened: false,
        pushForm: null,
        countUserText: '',
    };

    componentWillMount() {
        this.fetchApplication();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.match !== nextProps.match) {
            this.fetchApplication(nextProps.match.params.appId);
        }
        if (nextProps.subscribedToPush > 1) {
            this.setState({
                countUserText: nextProps.t(
                    'module.push.device_count_plural',
                    { count: nextProps.subscribedToPush },
                ),
            });
        } else {
            this.setState({
                countUserText: nextProps.t(
                    'module.push.device_count',
                    { count: nextProps.subscribedToPush },
                ),
            });
        }

    }

    // Fetch

    fetchApplication(appId = null) {
        if (this.props.match) {
            let id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id);
            }
        }
    }

    // Actions

    handlePush = () => {
        if (this.state.pushForm) {
            this.props.postPush(this.props.app.id, this.state.pushForm);
        }
        this.handleClosePushModal();
    };

    handleOpenPushModal = (formProps) => {
        this.setState({
            pushModalOpened: true,
            pushForm: formProps,
        });
    };

    handleClosePushModal = () => {
        this.setState({
            pushModalOpened: false,
            pushForm: null,
        });
        this.props.resetSubscribedPush();
    };

    handleFormSubmit = async (formProps) => {
        await this.props.getSubscribedPush(this.props.app.id, formProps);
        this.handleOpenPushModal(formProps);
    };

    // Render

    renderPushForm() {
        return (
            <div style={styles.empty.fullHeight}>
                {this.props.subscribedToPush && this.renderPushDialog()}
                <h3 style={style.navigation}>{this.props.t('generic.push')} - {this.props.app.name}</h3>
                <div className="row">
                    <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                        <Paper>
                            <Subheader
                                style={style.subHeader}>{this.props.t('generic.push')}</Subheader>
                            <div style={style.paper}>
                                <PushForm
                                    groups={this.props.app.push_groups}
                                    sounds={this.props.app.push_sounds}
                                    onSubmit={this.handleFormSubmit}
                                    submitting={this.props.sending}
                                />
                            </div>
                        </Paper>
                    </div>
                </div>
            </div>
        );
    }

    renderNoPushConfig() {
        return (
            <div style={styles.empty.fullHeight}>
                <div className="row" style={styles.empty.container}>
                    <div>
                        <div className="center-xs col-xs-12">
                            <img style={styles.empty.image} src={errorIcon} alt="empty" />
                        </div>
                        <div style={styles.empty.textContainer}
                             className="col-xs-offset-1 col-xs-10 col-sm-offset-2 col-sm-8 col-md-offset-3 col-md-6 col-lg-offset-4 col-lg-4">
                            <span style={styles.empty.title}>
                                {this.props.t('module.push.no_conf.title')}
                            </span><br /><br />
                            <span style={styles.empty.desc}>
                                <Link to={SETTING_PAGE.replace(':appId', this.props.app.id)}>
                                    {this.props.t('module.push.no_conf.desc')}
                                </Link>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderPushDialog() {
        const actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                primary={false}
                onClick={this.handleClosePushModal}
            />,
            <FlatButton
                label={this.props.t('generic.push')}
                primary={true}
                onClick={this.handlePush}
            />,
        ];
        return (
            <Dialog
                title={this.props.t('generic.push_notification')}
                actions={actions}
                modal={false}
                open={this.state.pushModalOpened}
                onRequestClose={this.handleClosePushModal}
            >
                <div dangerouslySetInnerHTML={{
                    __html:
                        this.props.t('module.push.push_confirmation', {
                            name: this.props.app.name,
                        }),
                }} />

                {this.props.subscribedToPush &&
                    <div dangerouslySetInnerHTML={{
                        __html: this.state.countUserText,
                    }} />
                }
            </Dialog>
        );
    }

    render() {
        if (this.props.error) {
            return (
                <Error
                    title={this.props.t('generic.error')}
                    subtitle={this.props.t('generic.error_loading')}
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app) {
            return <Loading paper={false} />;
        }

        let app = this.props.app;
        let config = app.configurations;

        if (config.push_server_id
            && config.push_server_key
            && config.push_server_token_dev
            && config.push_server_token_prod) {
            return this.renderPushForm();
        } else {
            return this.renderNoPushConfig();
        }
    }
}

function mapStateToProps(state) {
    return {
        app: state.apps.currentApplication,
        error: state.apps.error,
        loading: state.apps.pending,
        user: state.auth.content,
        subscribedToPush: state.apps.subscribedToPush,
    };
}

export default connect(mapStateToProps, {
    postPush,
    resetSubscribedPush,
    getSubscribedPush,
    fetchApp,
})(withTranslation(PushPage));



// WEBPACK FOOTER //
// src/containers/push/PushPage/PushPage.js